import { useContext } from 'react';
import { AuthContext } from '../store/authSlice';

/**
 * Access auth state and actions anywhere inside <AuthProvider>.
 *
 * Returns: { state, login, register, logout, clearError }
 */
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return ctx;
}
